import { archiveTabs } from "@/mocks/evidence";

export default function ArchiveBand() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <p className="eyebrow text-xs font-semibold text-primary-700">07 / 档案速览</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              上疏下密的证据库
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              顶部留给主编精选与头条，底部按类型铺满。往下翻，不同维度的证据都能各归其位。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4 lg:col-span-8">
            {archiveTabs.map((a) => (
              <a
                key={a.key}
                href="#timeline"
                className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-md bg-background-50 text-primary-600">
                  <i className="ri-database-2-line text-lg" />
                </div>
                <p className="mt-4 font-heading text-2xl font-bold text-foreground-950">
                  {a.count}
                </p>
                <p className="mt-1 text-sm text-foreground-500">{a.label}</p>
                <p className="mt-3 text-xs text-primary-700 opacity-0 transition-opacity group-hover:opacity-100">
                  进入查看 <i className="ri-arrow-right-line" />
                </p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}